export const formData = [
  {
    typeName: 'select1',
    placeholder: '请选择年级',
    model: 'equal[stage_tag_id]',
    options: [],
  },
  {
    typeName: 'select1',
    placeholder: '请选择学科',
    model: 'equal[subject_tag_id]',
    options: [],
  },
  {
    typeName: 'inputSearch',
    placeholder: '请输入课程包名称',
    model: 'like[name]',
  },
];



// WEBPACK FOOTER //
// ./src/views/MyCourse/packageList/fields.js